var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.022 44.2047C27.0377 43.9397 26.8311 43.7054 26.5598 43.6806L19.9265 43.0538C26.0624 40.8275 31.0442 36.3951 33.881 30.6374C36.7179 24.8798 37.202 18.2187 35.237 11.9781C35.0439 11.3871 34.1091 11.6469 34.2982 12.2455C36.1964 18.2613 35.7273 24.6847 32.9849 30.2322C30.2423 35.7795 25.4277 40.0429 19.5035 42.1697L22.665 36.6246L22.6651 36.6248C22.7665 36.3989 22.6729 36.1292 22.4489 36.0027C22.2252 35.8761 21.9451 35.9342 21.8029 36.1369L17.8106 43.1396C17.7348 43.2841 17.7407 43.4588 17.8261 43.6031C17.9117 43.7475 18.0652 43.8415 18.2333 43.8526L26.519 44.6354C26.7805 44.6472 27.0003 44.459 27.022 44.2047L27.022 44.2047Z",
    fill: "#9B7BD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow-2.71f66ceba1b95664592585ccf636812e.svg";
export { ForwardRef as ReactComponent };